// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ejC9","tabsBox":"styles_tabsBox__1BeEj","createButton":"styles_createButton__2FBg-"};